import { api } from '@/services'

export function findAll(params) {
  return api.get('/admin/recharge', { params })
}

export function advanceBalance(rechargeId) {
  return api.post(`/admin/recharge/advanceBalance/${rechargeId}`)
}

export function undoAdvanceBalance(rechargeId) {
  return api.post(`/admin/recharge/undoAdvanceBalance/${rechargeId}`)
}
